<template>
  <q-dialog title="订单修改记录" :visible="isVisible" width="40%" :innerScroll="false" :showFooter="false" @close="onClose">
    <div style="height: 50px; line-height: 50px">平台单号：{{ orderNo }}</div>
    <div>
      <el-table
        :data="recordData.records"
        v-loading="loading"
        border
        :height="300"
        element-loading-text="数据加载中"
        element-loading-spinner="el-icon-loading"
        :header-cell-style="{
          backgroundColor: '#FAFAFA',
          textAlign: 'center',
        }"
        :cell-style="{ textAlign: 'center' }"
        style="width: 100%"
      >
        <el-table-column prop="createdBy" label="操作人" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="createdDate" label="操作时间" :show-overflow-tooltip="true"></el-table-column>
      </el-table>
      <div style="text-align: right; margin-top: 15px">
        <el-pagination
          @size-change="onSizeChange"
          @current-change="onCurrentChange"
          :current-page="recordData.pageNum"
          :page-sizes="[30, 100, 500, 1000]"
          :page-size="recordData.pageSize"
          :total="recordData.total"
          background
          layout="total, sizes, prev, pager, next, jumper"
        >
        </el-pagination>
      </div>
    </div>
  </q-dialog>
</template>

<script>
export default {
  name: "RecordDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    orderNo: {
      type: String,
      default: "",
    },
    dataId: {
      type: [String, Number],
      default: "",
    },
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  data() {
    return {
      loading: false,
      recordData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
    };
  },
  watch: {
    visible(val) {
      if (val && this.dataId) {
        this.recordData.pageNum = 1;
        this.fetchData();
      }
    },
  },
  methods: {
    onClose() {
      this.isVisible = false;
    },
    fetchData() {
      this.loading = true;
      let param = {
        exportTag: true,
        filterData: {
          dateId: this.dataId,
        },
        pageNum: this.recordData.pageNum,
        pageSize: this.recordData.pageSize,
      };
      this.$q.dataImport
        .listOrderNoPage({ data: JSON.stringify(param) })
        .then((res) => {
          if (res.code == 200) {
            this.recordData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSizeChange(pageSize) {
      this.recordData.pageSize = pageSize;
      this.recordData.pageNum = 1;
      this.fetchData();
    },
    onCurrentChange(pageNum) {
      this.recordData.pageNum = pageNum;
      this.fetchData();
    },
  },
};
</script>

<style lang="stylus" scoped>
</style>
